import { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
import { DateTime } from 'luxon';

import {
  TeacherAssignmentTypeEnum,
  useGetQuizByIdQuery,
  useUpdateQuizMutation,
  TeacherQuizFragment,
} from '@school_ify/schoolify-repository/src/teacher/types';

import { CreateEditQuizModel } from 'types/quiz';

import CreateQuizForm from '../shared/CreateQuizForm/CreateQuizForm';
import QuestionsTable from './components/QuestionsTable/QuestionsTable';
import QuizQuestionTypeOptionCollection from './components/QuizQuestionTypeCollection/QuizQuestionTypeOptionCollection';

import './EditQuiz.scoped.scss';

interface ParamsProps {
  quizId: string;
}

const EditQuiz: React.FC = () => {
  const { quizId } = useParams<ParamsProps>();
  const [editQuiz, setEditQuiz] = useState<TeacherQuizFragment>(null);

  const data = useGetQuizByIdQuery({
    variables: {
      quizId,
    },
    onCompleted: fetchedData => {
      if (fetchedData) setEditQuiz(fetchedData?.assignments_by_pk || null);
    },
  });

  const refetchQuiz = () => {
    data.refetch({ quizId });
  };

  useEffect(() => {
    refetchQuiz();
  }, []);

  const [updateQuizMutation] = useUpdateQuizMutation();

  const updateQuiz = (model: CreateEditQuizModel) => {
    updateQuizMutation({
      variables: {
        assignment_id: model.id,
        assignment: {
          description: model.description,
          title: model.title,
          teaching_structure_id: model.teaching_structure_id,
          type: TeacherAssignmentTypeEnum.QUIZ,
          duration: model.duration,
          due_at: DateTime.now().toISO(),
        },
        assignment_quiz: {
          attempts: model.attempts,
          pass_percentage: model.passPercentage,
          time_control: model.timeControl,
        },
      },
    });
  };

  return (
    <div className="edit-quiz-container">
      <div className="edit-quiz-center">
        {editQuiz && (
          <div className="quiz-components-wrapper">
            <CreateQuizForm editQuiz={editQuiz} onSave={updateQuiz}>
              <>
                {editQuiz?.assignment_questions?.length > 0 && (
                  <QuestionsTable
                    questions={editQuiz?.assignment_questions}
                    refetchQuiz={refetchQuiz}
                  />
                )}
                <QuizQuestionTypeOptionCollection quizId={quizId} />
              </>
            </CreateQuizForm>
          </div>
        )}
      </div>
    </div>
  );
};

export default EditQuiz;
